export const wiki = {
  wiki: 'Wiki',
  homeH1: 'Wiki skinów CS2',
  homeSubtitle: 'Wszystkie skiny CS2: zużycie, rzadkość, skrzynki i kolekcje',
  categoriesTitle: 'Kategorie',
  featuredTitle: 'Skiny po ludzku',
  allWeaponsTitle: 'Cała broń',
  aboutWiki: 'O wiki',
  readMore: 'Czytaj dalej',
  showAll: 'Pokaż wszystkie: {{count}}',
  floatScaleLabel: 'Skala float od 0 do 1 i stan zużycia dla każdego przedziału',
  searchPlaceholder: 'Znajdź skina, broń lub skrzynkę',
  searchPlaceholderShort: 'Skin, broń lub skrzynka',
  searchSubmit: 'Szukaj',
  searchClear: 'Wyczyść wyszukiwanie',
  searchH1: 'Szukaj w wiki',
  searchResultsFor: 'Wyniki dla „{{q}}”',
  searchEmptyTitle: 'Nic nie znaleziono',
  searchEmptyText: 'Sprawdź pisownię lub spróbuj angielskiej nazwy.',
  searchEmptyTextLatin: 'Sprawdź pisownię lub skróć zapytanie.',
  searchOpenCatalog: 'Otwórz katalog',
  searchErrorTitle: 'Wyszukiwanie się nie załadowało',
  searchErrorText: 'Sprawdź połączenie i spróbuj ponownie.',
  searchShortQuery: 'Wpisz co najmniej dwa znaki.',
  retry: 'Spróbuj ponownie',
  suggestEmpty: 'Brak wyników',
  suggestAll: 'Pokaż wszystkie wyniki',
  typeSkin: 'Skin',
  typeWeapon: 'Broń',
  typeContainer: 'Skrzynka',
  typeCollection: 'Kolekcja',
  catPistols: 'Pistolety',
  catRifles: 'Karabiny',
  catSmgs: 'PM-y',
  catHeavy: 'Ciężkie',
  catKnives: 'Noże',
  catGloves: 'Rękawice',
  catEquipment: 'Wyposażenie',
  weaponsTitle: 'Broń',
  modelsTitle: 'Modele',
  selectionsTitle: 'Zestawienia',
  guidesTitle: 'Poradniki',
  containersTitle: 'Najnowsze skrzynki',
  allSkins: 'Wszystkie skiny',
  allGuides: 'Wszystkie poradniki',
  allSelections: 'Wszystkie zestawienia',
  allCases: 'Wszystkie skrzynki',
  allCollections: 'Wszystkie kolekcje',
  skinsOne: '{{count}} skin',
  skinsFew: '{{count}} skiny',
  skinsMany: '{{count}} skinów',
  knivesOne: '{{count}} nóż',
  knivesFew: '{{count}} noże',
  knivesMany: '{{count}} noży',
  glovesOne: '{{count}} para rękawic',
  glovesFew: '{{count}} pary rękawic',
  glovesMany: '{{count}} par rękawic',
  rareItemsOne: '{{count}} przedmiot',
  rareItemsFew: '{{count}} przedmioty',
  rareItemsMany: '{{count}} przedmiotów',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'Skiny CS2',
  catalogCategoryH1: 'Skiny CS2: {{category}}',
  filtersTitle: 'Filtry',
  filterWeapon: 'Broń',
  filterRarity: 'Rzadkość',
  filterCollection: 'Kolekcja',
  filterCase: 'Skrzynka',
  filterExterior: 'Zużycie',
  filterStatTrak: 'Z StatTrak™',
  filterSouvenir: 'Z Pamiątką',
  anyWeapon: 'Dowolna broń',
  anyRarity: 'Dowolna rzadkość',
  anyCollection: 'Dowolna kolekcja',
  anyCase: 'Dowolna skrzynka',
  removeFilter: 'Usuń filtr „{{name}}”',
  sortLabel: 'Sortowanie',
  sortRarity: 'Wg rzadkości',
  sortName: 'Wg nazwy',
  sortRelease: 'Najnowsze najpierw',
  sortPrice: 'Wg ceny',
  applyFilters: 'Pokaż',
  resetFilters: 'Resetuj filtry',
  resetShort: 'Resetuj',
  closeFilters: 'Zamknij filtry',
  catalogEmptyTitle: 'Brak skinów dla tych filtrów',
  catalogEmptyText: 'Usuń część filtrów albo zresetuj wszystkie.',
  prevPage: 'Wstecz',
  nextPage: 'Dalej',
  pageOf: 'Strona {{page}} z {{count}}',
  foundCount: 'Znaleziono: {{count}}',
  foundCountMasculine: 'Znaleziono: {{count}}',
  priceFrom: 'od {{price}}',
  weaponAllFilters: 'Wszystkie filtry w katalogu',
  breadcrumbs: 'Ścieżka nawigacji',
  exteriorFn: 'Prosto z fabryki',
  exteriorMw: 'Lekkie zużycie',
  exteriorFt: 'Po testach bojowych',
  exteriorWw: 'Mocne zużycie',
  exteriorBs: 'Po ciężkich walkach',
  kindNormal: 'Zwykły',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Pamiątka',
  vanillaFinish: 'Vanilla',
  phasesTitle: 'Fazy',
  statsTitle: 'Szczegóły',
  statWeapon: 'Broń',
  statFinish: 'Wykończenie',
  statRarity: 'Rzadkość',
  statFloat: 'Zakres float',
  statExteriors: 'Stany zużycia',
  statKinds: 'Wersje',
  statCollections: 'Kolekcja',
  statContainers: 'Skrzynki',
  statRelease: 'Rok wydania',
  rareItem: 'rzadki przedmiot specjalny',
  rareDropNote: 'Wypada jako rzadki przedmiot specjalny ★',
  pricesTitle: 'Ceny Steam',
  pricesHint: 'Cena na Rynku Społeczności Steam w dolarach amerykańskich.',
  priceAsOf: 'Aktualizacja: {{date}}.',
  noPrice: 'Brak aktualnych danych',
  noPriceMarked: 'Brak aktualnych danych dla zaznaczonych wersji',
  gameDescriptionTitle: 'Opis w grze',
  faqTitle: 'FAQ',
  similarTitle: 'Podobne skiny',
  shotTitle: 'Dostępny w SHOT',
  shotHint: 'Ten skin jest w tych skrzynkach SHOT.',
  dropsTitle: 'Ostatnie dropy',
  dropsHint: 'Kto go zdobył w SHOT i gdzie.',
  dropsCase: 'Skrzynka „{{name}}”',
  dropsCaseBattle: 'Case Battle',
  dropsUpgrade: 'Upgrade',
  dropsContract: 'Kontrakt',
  dropsRushMid: 'Rush Mid',
  dropsRoulette: 'Rosyjska ruletka',
  timeJustNow: 'przed chwilą',
  timeMinutesAgo: '{{count}} min temu',
  timeHoursAgo: '{{count}} godz. temu',
  timeDaysAgo: '{{count}} d. temu',
  englishName: 'Nazwa angielska',
  caseReleased: 'Wydana w {{year}} roku',
  rareTitle: 'Rzadkie przedmioty specjalne',
  compositionTitle: 'Skiny w środku',
  rareHintKnives: 'Noże wypadają z tej skrzynki jako osobny rzadki przedmiot specjalny.',
  rareHintGloves: 'Rękawice wypadają z tej skrzynki jako osobny rzadki przedmiot specjalny.',
  rareHintKnivesAndGloves: 'Noże i rękawice wypadają z tej skrzynki jako osobny rzadki przedmiot specjalny.',
  rareKnives: 'noże',
  rareGloves: 'rękawice',
  rareKnivesAndGloves: 'noże i rękawice',
  caseCollectionTitle: 'Kolekcja skrzynki',
  collectionCasesTitle: 'Skrzynki z tą kolekcją',
  collectionReleased: 'Wydana w {{year}} roku',
  tocTitle: 'Spis treści',
  reviewedOn: 'Sprawdzono {{date}}',
  reviewedBy: 'Sprawdzone przez redakcję SHOT · {{date}}',
  shortAnswer: 'W skrócie',
  guidesH1: 'Poradniki o skinach CS2',
  selectionsH1: 'Zestawienia skinów CS2',
  casesH1: 'Skrzynki CS2',
  collectionsH1: 'Kolekcje CS2',
  weaponSkinsH1: 'Skiny {{weapon}}',
};

export const wikiItem = {
  typeSticker: 'Naklejka',
  typeAgent: 'Agent',
  typeCharm: 'Przywieszka',
  typeMusicKit: 'Zestaw utworów',
  typePatch: 'Naszywka',
  typeGraffiti: 'Graffiti',
  typePin: 'Przypinka',
  sectionStickers: 'Naklejki',
  sectionAgents: 'Agenci',
  sectionCharms: 'Przywieszki',
  sectionMusicKits: 'Zestawy utworów',
  sectionPatches: 'Naszywki',
  sectionGraffiti: 'Graffiti',
  sectionPins: 'Przypinki',
  kindCase: 'Skrzynka',
  kindStickerCapsule: 'Kapsuła z naklejkami',
  kindAutographCapsule: 'Kapsuła z autografami',
  kindSouvenirPackage: 'Paczka pamiątkowa',
  kindMusicKitBox: 'Pudełko z zestawem utworów',
  kindPatchCapsule: 'Paczka naszywek',
  kindPinsCapsule: 'Kapsuła z przypinkami',
  kindGraffitiBox: 'Pudełko z graffiti',
  tabAll: 'Wszystko',
  tabCases: 'Skrzynki',
  tabStickerCapsules: 'Kapsuły z naklejkami',
  tabAutographCapsules: 'Kapsuły z autografami',
  tabSouvenirPackages: 'Paczki pamiątkowe',
  tabMusicKitBoxes: 'Pudełka z zestawami utworów',
  tabPatchCapsules: 'Paczki naszywek',
  tabPinsCapsules: 'Kapsuły z przypinkami',
  tabGraffitiBoxes: 'Pudełka z graffiti',
  kindsNavLabel: 'Rodzaje pojemników',
  containersH1: 'Skrzynki i kapsuły CS2',
  h1StickerCapsules: 'Kapsuły z naklejkami CS2',
  h1AutographCapsules: 'Kapsuły z autografami CS2',
  h1SouvenirPackages: 'Paczki pamiątkowe CS2',
  h1MusicKitBoxes: 'Pudełka z zestawami utworów CS2',
  h1PatchCapsules: 'Paczki naszywek CS2',
  h1PinsCapsules: 'Kapsuły z przypinkami CS2',
  h1GraffitiBoxes: 'Pudełka z graffiti CS2',
  stickersOne: '{{count}} naklejka',
  stickersFew: '{{count}} naklejki',
  stickersMany: '{{count}} naklejek',
  musicKitsOne: '{{count}} zestaw utworów',
  musicKitsFew: '{{count}} zestawy utworów',
  musicKitsMany: '{{count}} zestawów utworów',
  patchesOne: '{{count}} naszywka',
  patchesFew: '{{count}} naszywki',
  patchesMany: '{{count}} naszywek',
  pinsOne: '{{count}} przypinka',
  pinsFew: '{{count}} przypinki',
  pinsMany: '{{count}} przypinek',
  graffitiOne: '{{count}} graffiti',
  graffitiFew: '{{count}} graffiti',
  graffitiMany: '{{count}} graffiti',
  colorsOne: '{{count}} kolor',
  colorsFew: '{{count}} kolory',
  colorsMany: '{{count}} kolorów',
  inGameSince: 'W grze od {{year}} roku',
  contentsTitle: 'Co jest w środku',
  variantsTitle: 'Warianty',
  groupSticker: 'Naklejka',
  groupSlab: 'W oprawie',
  effectPaper: 'Papierowa',
  effectHolo: 'Holo',
  effectFoil: 'Foliowana',
  effectGold: 'Złota',
  effectGlitter: 'Brokatowa',
  effectLenticular: 'Soczewkowa',
  effectEmbroidered: 'Haftowana',
  stickerAutograph: 'Autograf',
  stickerTeam: 'Drużyna',
  stickerEvent: 'Turniej',
  stickerOther: 'Inne',
  sideT: 'Terroryści',
  sideCt: 'Antyterroryści',
  statType: 'Typ',
  statStickerKind: 'Typ naklejki',
  statTournament: 'Turniej',
  statTeam: 'Drużyna',
  statPlayer: 'Gracz',
  statEffects: 'Efekty',
  statSlab: 'W oprawie',
  statSide: 'Strona',
  statArtist: 'Autor',
  statStatTrak: 'StatTrak™',
  statColors: 'Kolory',
  valueYes: 'Jest',
  valueNo: 'Brak',
  whereTitle: 'Gdzie zdobyć',
  whereCollection: 'Kolekcja',
  whereStickerPack: 'Paczka naklejek',
  shotHintItem: 'Ten przedmiot wypada z tych skrzynek SHOT.',
  souvenirPackagesRow: 'Paczki pamiątkowe',
  moreCount: 'jeszcze {{count}}',
  typeHighlight: 'Przywieszka z momentem',
  typePass: 'Przepustka',
  typeKey: 'Klucz',
  sectionHighlights: 'Przywieszki z momentami',
  sectionPasses: 'Przepustki',
  sectionKeys: 'Klucze',
  kindOther: 'Paczka',
  tabOther: 'Inne',
  h1Other: 'Inne paczki CS2',
  itemsOne: '{{count}} przedmiot',
  itemsFew: '{{count}} przedmioty',
  itemsMany: '{{count}} przedmiotów',
  statEvent: 'Turniej',
  statStage: 'Etap',
  statMap: 'Mapa',
  statTeams: 'Mecz',
  statVideo: 'Wideo',
  watchVideo: 'Zobacz ten moment',
  statOpens: 'Otwiera',
  listH1Stickers: 'Naklejki CS2',
  listH1Agents: 'Agenci CS2',
  listH1Charms: 'Przywieszki CS2',
  listH1MusicKits: 'Zestawy utworów CS2',
  listH1Patches: 'Naszywki CS2',
  listH1Graffiti: 'Graffiti CS2',
  listH1Highlights: 'Przywieszki z momentami CS2',
  listH1Pins: 'Przypinki CS2',
  listH1Passes: 'Przepustki CS2',
  listH1Keys: 'Klucze do skrzynek CS2',
  listCount: '{{count}} w grze',
  typeCollectible: 'Przedmiot kolekcjonerski',
  sectionCollectibles: 'Monety, medale i trofea',
  listH1Collectibles: 'Monety, medale i trofea CS2',
  collectibleCoin: 'Moneta',
  collectibleTrophy: 'Trofeum',
  collectibleMedal: 'Medal',
  versionNumber: 'Wersja {{n}}',
  allItemsTitle: 'Wszystkie przedmioty',
  sectionContainers: 'Skrzynki i kapsuły',
};
